import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import ReduxHoursDetails from 'containers/fe/ReduxHoursDetails.jsx';
import ReduxTrasHoursDetails from 'containers/fe/ReduxTrasHoursDetails.jsx';

class ModalHoursDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = () => {
    this.setState({
      modalIsOpen: true,
    });
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    let description;
    if (!this.props.trasversal) {
      description = 'Elenco ore divise per forma didattica:';
    } else {
      description = 'Elenco ore divise per attivita:';
    }
    return (
      <div className="inline">
        <Button
          onClick={this.openModal}
          size="small"
          type="primary"
        >
          Dettagli
        </Button>
        <Modal
          title="Dettaglio Ore di attivita"
          visible={this.state.modalIsOpen}
          maskClosable={false}
          onCancel={() => this.closeModal()}
          footer={[<Button key="back" onClick={this.closeModal}>Ok</Button>]}
        >
          <p>{description}</p>
          {
            !this.props.trasversal &&
              <ReduxHoursDetails />
          }
          {
            this.props.trasversal &&
              <ReduxTrasHoursDetails />
          }
        </Modal>
      </div>
    );
  }
}

ModalHoursDetail.propTypes = {
  trasversal: PropTypes.bool,
};

export default ModalHoursDetail;
